// libs/core/config/src/lib/app-config.token.ts
import { InjectionToken } from '@angular/core';

export type AppConfig = {
  appName: string;
  brandPrimary: string;
  brandLogoUrl: string;
  mascoteLogo: string;
  version?: string;

  /**
   * POC Brand Kernel:
   * URL absoluta do mock/serviço que controla identidade visual viva.
   */
  brandKernelApiUrl?: string;

  /**
   * Liga/desliga realtime de identidade visual.
   * No fluxo atual fica false, porque a fonte da verdade é o GET /company
   * após salvar ou recarregar a aplicação.
   */
  brandRealtimeEnabled?: boolean;

  environmentName: 'local' | 'dev' | 'prod';
  apiBaseUrl: string;

  tenantSlug: string;

  // storage key por tenant (evita colidir)
  authStorageKey: string;

  // WhatsApp do estabelecimento (ex: 5511999999999)
  whatsapp?: string;
  heroBannerUrl?: string;
};
export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');